import { Highlighter } from './highlighter';
import { ToolName } from './tool-name.enum';
import { Brush } from './brush';
import { Eraser } from './eraser';
import { Line } from './line';
import { Rectangle } from './rectangle';
import { Circle } from './circle';
import { RectangularTriangle } from './rectangular-triangle';
import { IsoscelesTriangle } from './isosceles-triangle';

export const ToolsMap = {
  [ToolName.Brush]: Brush,
  [ToolName.Eraser]: Eraser,
  [ToolName.Line]: Line,
  [ToolName.Rectangle]: Rectangle,
  [ToolName.Circle]: Circle,
  [ToolName.RectangularTriangle]: RectangularTriangle,
  [ToolName.IsoscelesTriangle]: IsoscelesTriangle,
  [ToolName.Highlighter]: Highlighter,
};
